// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button---caVmr {
  width: 171px;
  height: 37px;
  padding: 0;
  margin: 0;
  background: #0095f6;
  border: none;
  border-radius: 5px;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 200ms ease;
}
.button---caVmr:hover {
  background: #0286dc;
}
@media (max-width: 991.98px) {
  .button---caVmr {
    width: 152px;
    height: 33px;
    background: none;
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    font-size: 12px;
    color: #757575;
  }
  .button---caVmr:hover {
    background: none;
    border: 1px solid #a6a6a8;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/link_button.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EAEA,mBAAA;EACA,YAAA;EACA,kBAAA;EAEA,iDAAA;EACA,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,eAAA;EACA,uCAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AAOA;EACE;IACE,YAAA;IACA,YAAA;IACA,gBAAA;IACA,yBAAA;IACA,kBAAA;IAEA,eAAA;IACA,cAAA;EANF;EAQE;IACE,gBAAA;IACA,yBAAA;EANJ;AACF","sourcesContent":[".button {\n  width: 171px;\n  height: 37px;\n  padding: 0;\n  margin: 0;\n\n  background: #0095f6;\n  border: none;\n  border-radius: 5px;\n\n  font-family: 'Segoe UI', Roboto, Helvetica, Arial;\n  font-size: 13px;\n  font-weight: 500;\n\n  color: #ffffff;\n  letter-spacing: 0;\n  text-align: center;\n  line-height: 20px;\n\n  cursor: pointer;\n  transition: background-color 200ms ease;\n\n  &:hover {\n    background: #0286dc;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .button {\n    width: 152px;\n    height: 33px;\n    background: none;\n    border: 1px solid #d8d8d8;\n    border-radius: 5px;\n\n    font-size: 12px;\n    color: #757575;\n\n    &:hover {\n      background: none;\n      border: 1px solid #a6a6a8;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button---caVmr`
};
export default ___CSS_LOADER_EXPORT___;
